import { render, staticRenderFns } from "./ScoutTabLiked.vue?vue&type=template&id=655154e8"
import script from "./ScoutTabLiked.vue?vue&type=script&lang=js"
export * from "./ScoutTabLiked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports